import { Link } from '@tanstack/react-router';
import { Trans, Plural } from '@lingui/react/macro';
import { useCurrentUser } from '../services/userHooks';
import { useHomeBookmarks } from '../services/dataHooks';
import { useUserPreferences } from '../hooks/useUserPreferences';
import SelectionStack from './Reader/SelectionStack';
import ThemeLogo from './ui/ThemeLogo';

function NotFoundPage() {
  const { currentUser } = useCurrentUser();
  const { preferences } = useUserPreferences();
  const { bookmarks } = useHomeBookmarks();

  const unreadCount = currentUser?.counts?.unread ?? 0;
  const hasUnread = unreadCount > 0;

  // Mirror the reader's empty-state stack: the top few home articles that have
  // a preview image, reversed so the newest renders on top of the stack.
  const framesToShow = bookmarks
    .filter((bookmark) => Boolean(bookmark.og_image))
    .slice(0, 3)
    .reverse();

  return (
    <div className="bg-surface-primary flex min-h-screen flex-col items-center justify-start gap-3 px-6 pt-[20vh] text-center">
      <ThemeLogo className="mb-2 h-9" />
      <h1 className="text-copy-primary text-2xl font-semibold">
        <Trans>This page appears to have instavanished.</Trans>
      </h1>
      <p className="text-copy-secondary max-w-sm text-sm">
        <Trans>Let's forget this whole 404 thing ever happened.</Trans>
      </p>
      {framesToShow.length > 0 && (
        <div className="selection-stack mt-2">
          <SelectionStack
            bookmarks={framesToShow}
            showThumbnails={preferences.bookmarkList.thumbnails}
            allowPlaceholderFallback={false}
          />
        </div>
      )}
      <Link to="/home" className="button-primary mt-2">
        {hasUnread ? (
          <Plural
            value={unreadCount}
            one="View your # article"
            other="View your # articles"
          />
        ) : (
          <Trans>Back home</Trans>
        )}
      </Link>
    </div>
  );
}

export default NotFoundPage;
